import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchUsers_idMake_primary = z.any()
export type TagsPatchUsers_idMake_primary = z.infer<typeof tagsPatchUsers_idMake_primary>

export const descriptionPatchUsers_idMake_primary = z.any()
export type DescriptionPatchUsers_idMake_primary = z.infer<typeof descriptionPatchUsers_idMake_primary>

export const paramsPatchUsers_idMake_primary = z.object({ "id": z.string().uuid() })
export type ParamsPatchUsers_idMake_primary = z.infer<typeof paramsPatchUsers_idMake_primary>

export const responsePatchUsers_idMake_primary = z.any()
export type ResponsePatchUsers_idMake_primary = z.infer<typeof responsePatchUsers_idMake_primary>

interface IPatchUsers_idMake_primary extends BaseMethodType {
  tags: TagsPatchUsers_idMake_primary,
  description: DescriptionPatchUsers_idMake_primary,
  params: ParamsPatchUsers_idMake_primary,
  response: ResponsePatchUsers_idMake_primary
}
export const URL = '/users/:id/make-primary'
export const validation = {
  patch: {
    tags: tagsPatchUsers_idMake_primary,
    description: descriptionPatchUsers_idMake_primary,
    params: paramsPatchUsers_idMake_primary,
    response: responsePatchUsers_idMake_primary
  }
}
export interface Users_idMake_primary extends BaseRouteType {
  patch: IPatchUsers_idMake_primary
}